import { render, staticRenderFns } from "./ProjectRoomCreator.vue?vue&type=template&id=97bd805a&scoped=true"
import script from "./ProjectRoomCreator.vue?vue&type=script&lang=js"
export * from "./ProjectRoomCreator.vue?vue&type=script&lang=js"
import style0 from "./ProjectRoomCreator.vue?vue&type=style&index=0&id=97bd805a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bd805a",
  null
  
)

export default component.exports